import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { measureDimensions } from "../../../../../../redux/measure-dimensions/action";
import { selectMeasureDimensionsListItems } from "../../../../../../redux/measure-dimensions/selector";

const ManagementMeasureDimensions = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const measureDimensionItems = useSelector(selectMeasureDimensionsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'SystemKeyword', headerName: 'System Keyword' },
          { field: 'Ratio', headerName: 'Ratio' },
          { field: 'IsPrimaryDimension', headerName: 'Primary Dimension', cellRenderer: 'yesNoRenderer' },
          { field: 'DisplayOrder', headerName: 'Display Order' }
      
        ]);
      }
      const fetchMeasureDimensions=()=>{

        dispatch(measureDimensions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/list`,entity:'measureDimensions',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchMeasureDimensions()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add MeasureDimensions',
      callback: () => handleAdd(),
    }
  ];
  const handleAdd=()=>{
    navigate(`/management/configuration/shipment/measure-dimensions/${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`/management/configuration/shipment/measure-dimensions/${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(measureDimensions.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/delete`,
      entity: 'measureDimensions',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(measureDimensions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/list`,entity:'measureDimensions',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {measureDimensionItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={measureDimensionItems?.result?.items} setPageData={setPageData}
    paginationData={measureDimensionItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Measure Dimensions" />
  }
  </> 
     
	);
};

export default ManagementMeasureDimensions;


